import { Box, FormLabel, NumberDecrementStepper, NumberIncrementStepper, NumberInput, NumberInputField, NumberInputStepper } from "@chakra-ui/react";
import { translate } from "../../../i18n";
import { typography } from 'theme/tokens';

export default function DurationInput({ durationInMs, setDuration }: { durationInMs: number, setDuration: (duration: number) => void }) {
    return (
        <Box>
            <NumberInput
                w="120px"
                value={durationInMs / (60 * 1000) || 0}
                min={0}
                step={30}
                precision={0}
                onChange={(_valueAsString, valueAsNumber) => {
                    setDuration(valueAsNumber * 60 * 1000);
                }}
            >
                <NumberInputField />
                <NumberInputStepper>
                    <NumberIncrementStepper />
                    <NumberDecrementStepper />
                </NumberInputStepper>
            </NumberInput>
            <FormLabel {...typography.formLabel} fontSize="sm" mt={1}>{translate('game_durations.duration_minutes')}</FormLabel>
        </Box>
    )
}